const SettingsComponent = () => {
  return (
    <>
      <div className="d-flex flex-column-fluid align-items-start container-xxl">
        <div className="flex-row-fluid mt-5" id="kt_content ">
          <div className="card">
            <div className="card-body py-15">
              <div className="mw-lg-950px mx-auto w-100">
                <div className="pb-12">
                  <div className="d-flex flex-column gap-7">
                  <h2 className='mt-5 mb-0'>Overview</h2>
                  <p className="text-gray-700">
                    The Merchant Console provides you with a centralized hub for configuring and managing key aspects of your account. From here, you can customize your store preferences, set up payment gateways, manage tax and shipping rules, and adjust notification settings. Whether you're adjusting branding options, updating your business details, or controlling access permissions for your team, this page offers a streamlined interface designed for ease of use and flexibility. All changes you make here are instantly reflected across your store and other connected services, ensuring your operations run smoothly and in line with your preferences.
                  </p>
                  <p className="text-gray-700">
                    In addition to core configuration options, the Settings page also gives you access to advanced features such as integration with third-party tools, API management, and security settings. You can review and update your store’s performance analytics, manage subscription plans, and control how your customers interact with your store’s checkout process. With a focus on empowering merchants to manage their business with full control and efficiency, this page is an essential part of optimizing your workflow and ensuring that your store meets all of your operational and regulatory needs.
                  </p>
                  <div className="separator separator-dashed my-3"></div>
                  <h4 className="mb-0">Configurations:</h4>
                  <span className="text-gray-700 text-italic">In active development**</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>          
    </>
  )
}

const SettingsWrapper = () => (
    <SettingsComponent />
)

export {SettingsWrapper}